<p-dropdown
  ngSkipHydration
  [options]="filterOptions"
  [(ngModel)]="selectedFilter"
  (onChange)="onFilterChange()"
  [dropdownIcon]="null"
  optionLabel="label"
>
  <ng-template pTemplate="selectedItem">
    <search-movie-filter-item [iconOnly]="true" [searchMovieFilter]="selectedFilter" />
  </ng-template>
  <ng-template let-filter pTemplate="item">
    <search-movie-filter-item [searchMovieFilter]="filter"></search-movie-filter-item>
  </ng-template>
</p-dropdown>
